import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';

const AppTabsSection = () => {
  return (
    <section className="py-10 lg:py-20" data-cy="app-tabs-section">
      <LandingPageCards
        rounded="3xl"
        cards={[
          {
            id: 'bedtime-app-ui-tab',
            title: { messageKey: 'membership_redesign_bedtime_app_ui_title' },
            description: {
              messageKey: 'membership_redesign_bedtime_app_ui_copy',
            },
            image: {
              localizedAlt: 'membership_redesign_bedtime_app_ui_alt',
              localizedSrc: 'membership_redesign_bedtime_app_ui',
              format: 'png',
            },
          },
          {
            id: 'vitals-app-ui-tab',
            title: { messageKey: 'membership_redesign_vitals_app_ui_title' },
            description: {
              messageKey: 'membership_redesign_vitals_app_ui_copy',
            },
            image: {
              localizedAlt: 'membership_redesign_vitals_app_ui_alt',
              localizedSrc: 'membership_redesign_vitals_app_ui',
              format: 'png',
            },
          },
          {
            id: 'health-app-ui-tab',
            title: { messageKey: 'membership_redesign_health_app_ui_title' },
            description: {
              messageKey: 'membership_redesign_health_app_ui_copy',
            },
            image: {
              localizedAlt: 'membershipt_redesign_health_app_ui_alt',
              localizedSrc: 'membership_redesign_health_app_ui',
              format: 'png',
            },
          },
        ]}
      />
    </section>
  );
};

export default AppTabsSection;
